<template>
  <transition name="fade">
    <base-card :title="$t('menu.appointment-info')" v-if="summary">
      <labeled-text :label="$t('appointment-info.date')" :text="summary.scheduledDateTime | beautifyDate"></labeled-text>
      <labeled-text :label="$t('appointment-info.disease')" :text="$i18nHelpers.normalize(summary.disease)"></labeled-text>
      <labeled-text :label="$t('appointment-info.reason')" :text="summary.reason"></labeled-text>
    </base-card>
  </transition>
</template>

<script>
import BaseCard from '@/components/base/ui/BaseCard.vue'
import LabeledText from '@/components/base/ui/LabeledText.vue'
import LoadingAnim from '@/components/utils/LoadingAnim.vue'

export default {
  name: 'appointment-info',
  components: {
    BaseCard,
    LabeledText,
    LoadingAnim
  },
  data () {
    return {
      summary: null
    }
  },
  created () {
    this.loadAppointmentInfo()
  },
  methods: {
    loadAppointmentInfo () {
      this.$api.get(`appointments/summary/${this.$store.state.appointment.id}`).then((response) => {
        this.summary = response.data.data
      })
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/shared/AppointmentInfo.vue